import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { MDXProvider } from '@mdx-js/react';
import { RecipeCard, Grid } from '../..';
import FlexboxGrid from './flexbox-grid.mdx';
import FlexboxWrap from './flexbox-wrap.mdx';
import FlexboxAlign from './flexbox-align.mdx';
import ImageCard from './image-card.mdx';
import BackgroundImageCard from './background-image-card.mdx';
import NavBar from './nav-bar.mdx';
import VideoEmbed from './video-embed.mdx';
import Container from './container.mdx';
import Avatar from './avatar.mdx';
import Badge from './badge.mdx';
import NavLink from './nav-link.mdx';
export const title = 'Recipes';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "recipes"
    }}>{`Recipes`}</h1>
    <p>{`Quick copy-and-paste code examples using Rebass.`}</p>
    <MDXProvider components={{
      wrapper: RecipeCard
    }} mdxType="MDXProvider">
      <Grid mdxType="Grid">
        <ul>
          <li parentName="ul">
            <FlexboxGrid href='/recipes/flexbox-grid' mdxType="FlexboxGrid" />
          </li>
          <li parentName="ul">
            <FlexboxWrap href='/recipes/flexbox-wrap' mdxType="FlexboxWrap" />
          </li>
          <li parentName="ul">
            <FlexboxAlign href='/recipes/flexbox-align' mdxType="FlexboxAlign" />
          </li>
          <li parentName="ul">
            <NavBar href='/recipes/nav-bar' mdxType="NavBar" />
          </li>
          <li parentName="ul">
            <ImageCard href='/recipes/image-card' mdxType="ImageCard" />
          </li>
          <li parentName="ul">
            <BackgroundImageCard href='/recipes/background-image-card' mdxType="BackgroundImageCard" />
          </li>
          <li parentName="ul">
            <VideoEmbed href='/recipes/video-embed' mdxType="VideoEmbed" />
          </li>
          <li parentName="ul">
            <Container href='/recipes/container' mdxType="Container" />
          </li>
          <li parentName="ul">
            <Avatar href='/recipes/avatar' mdxType="Avatar" />
          </li>
          <li parentName="ul">
            <Badge href='/recipes/badge' mdxType="Badge" />
          </li>
          <li parentName="ul">
            <NavLink href='/recipes/nav-link' mdxType="NavLink" />
          </li>
        </ul>
      </Grid>
    </MDXProvider>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      